// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"f050ec2d","356":"d44fd6ef","453":"581c6c7e"}[chunkId] + ".chunk.js";
};